export default __webpack_public_path__ + "static/media/achievements.925eeeee.mp4";